import { MapTo } from '@adobe/aem-react-editable-components';
import SearchRibbon, { SearchRibbonEditConfig } from './SearchRibbon';

export default MapTo('cob-corp-acquisition/components/creditonebank/search-ribbon')(SearchRibbon, SearchRibbonEditConfig);
